/** Text mode: billed seconds = ceil(charCount / 10). */
export const LIP_SYNC_TEXT_CHARS_PER_SECOND = 10;

/** Ceil raw media seconds for billing / API `duration`. */
export function ceilBillingSeconds(seconds) {
  const value = Number(seconds);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.ceil(value);
}

export function estimateTextBillingSeconds(charCount) {
  const count = Math.max(0, Number(charCount) || 0);
  if (count <= 0) return 0;
  return Math.ceil(count / LIP_SYNC_TEXT_CHARS_PER_SECOND);
}

/** credits = billedSeconds × creditPerSecond (billedSeconds already ceiled). */
export function estimateBillingCredits(billedSeconds, creditPerSecond) {
  const seconds = ceilBillingSeconds(billedSeconds);
  const rate = Number(creditPerSecond) || 0;
  if (seconds <= 0 || rate <= 0) return 0;
  return seconds * rate;
}
